// these are extensions for tailwindcss
// see tailwindcss.com
// if you are unfamiliar with tailwind do not add themes here because
// they could override existing tailwind classes
// add themes to the theme file

const tailwindExtensions = {
  fontSize: {
    "xxxs": ".5rem",
    "xxs": ".625rem",
    "md": "1rem",
    "3xl": "2rem",
    "6.5xl": "4.5rem",
  },
  fontFamily: {
    title: ["Gilroy", "sans-serif"],
    body: ["Gilroy", "sans-serif"],
  },
  colors: {
    "green-primary": "#26E3BA",
    "green-primary-light": "#70E2CA",
    "green-secondary": "#BFF1E7",
    "green-boost-btn": `#00A588`,
    "green-dark": "#001713",
    "black-primary": "#011516",
    "black-secondary": "#030E0E",
    "gray-boost-text": "#6A6A6A",
    "boost-primary-purple": "#4B2BA3",
    "boost-txt-white": "#EEFFFC",
    "boost-input-gray": "#D9D9D9",
    "boost-text-gray": "#818181",
    "off-white": "#FCFCFC",
    "background": "#FAFAFA",
    "gray-primary": "#7aa4a7",
    "gray-secondary": "#D8D8D8",
    "support": "#152D2D",
    "critical": "#FF8080",
    "warning": "#FFCC67",
    "fog-gray": "#DAE1E9",
    "beige": "#FFF0D5",
    "boost-primary": "#4B2BA3",
    "boost-secondary": "#C093FF",
    "boost-light-purple": "#8154FE",
    "boost-lighter-purple": "#B296FF",
    "boost-gold": "#8C6D00",
    "boost-light-gold": "#E1AF00",
    "boost-black": "#020202",
    "boost-trial-ending-red": "#FF8D93",
    "stripe-error-red": "#DF1B41",
    /*
      below are colors from design doc Earth 1.0
      https://www.figma.com/file/YdAGQzOd0bkXHPEdvpkV92/Earth-(1.0)
      may have some overlaps with the existing. should migrate to the new color classname
    */
    // neutral
    "neutral-700": "#1F1F1F",
    "neutral-600": "#4B4B4B",
    "neutral-500": "#8E8E8E",
    "neutral-400": "#CACACA",
    "neutral-300": "#E1E1E1",
    "neutral-200": "#EEEEEE",
    "neutral-100": "#F5F5F5",
    "neutral-50": "#FAFAFA",
    // primary
    "boost-primary-700": "#472C9B",
    "boost-primary-600": "#5C3BC8",
    "boost-primary-500": "#7249F5",
    "boost-primary-400": "#8E6DF7",
    "boost-primary-300": "#AA92F9",
    "boost-primary-200": "#C7B6FB",
    "boost-primary-100": "#E3DBFD",
    "boost-primary-50": "#F1EDFE",
    // error
    "error-700": "#8C3133",
    "error-600": "#B74143",
    "error-500": "#E25153",
    "error-400": "#E87475",
    "error-300": "#EE9798",
    "error-200": "#F3B9BA",
    "error-100": "#F9DCDD",
    "error-50": "#FCEEEE",
    // warning
    "warning-700": "#FE9B0E",
    "warning-600": "#FFAD0D",
    "warning-500": "#FFC62B",
    "warning-400": "#FFDD82",
    "warning-300": "#FFEAB3",
    "warning-200": "#FFF7E1",
    "warning-100": "#FFF9EE",
    "warning-50": "#FFFDFA",
    // success
    "success-700": "#0C9D61",
    "success-600": "#47B881",
    "success-500": "#6BC497",
    "success-400": "#97D4B4",
    "success-300": "#C0E5D1",
    "success-200": "#E5F5EC",
    "success-100": "#F2FAF6",
    "success-50": "#FBFEFC",
    // information
    "info-700": "#3A70E2",
    "info-600": "#3B82F6",
    "info-500": "#4BA1FF",
    "info-400": "#93C8FF",
    "info-300": "#BDDDFF",
    "info-200": "#E4F2FF",
    "info-100": "#F1F8FF",
    "info-50": "#F8FCFF",

    "transparent": "transparent",
    "current": "currentColor",

    "black": "#000",
    "white": "#fff",

    "gray": {
      100: "#f7fafc",
      200: "#edf2f7",
      300: "#e2e8f0",
      400: "#cbd5e0",
      500: "#a0aec0",
      600: "#718096",
      700: "#4a5568",
      800: "#2d3748",
      900: "#1a202c",
    },
    "red": {
      100: "#fff5f5",
      200: "#fed7d7",
      300: "#feb2b2",
      400: "#fc8181",
      500: "#f56565",
      600: "#e53e3e",
      700: "#c53030",
      800: "#9b2c2c",
      900: "#742a2a",
    },
    "orange": {
      100: "#fffaf0",
      200: "#feebc8",
      300: "#fbd38d",
      400: "#f6ad55",
      500: "#ed8936",
      600: "#dd6b20",
      700: "#c05621",
      800: "#9c4221",
      900: "#7b341e",
    },
    "yellow": {
      100: "#fffff0",
      200: "#fefcbf",
      300: "#faf089",
      400: "#f6e05e",
      500: "#ecc94b",
      600: "#d69e2e",
      700: "#b7791f",
      800: "#975a16",
      900: "#744210",
    },
    "green": {
      100: "#f0fff4",
      200: "#c6f6d5",
      300: "#9ae6b4",
      400: "#68d391",
      500: "#48bb78",
      600: "#38a169",
      700: "#2f855a",
      800: "#276749",
      900: "#22543d",
    },
    "teal": {
      100: "#e6fffa",
      200: "#b2f5ea",
      300: "#81e6d9",
      400: "#4fd1c5",
      500: "#38b2ac",
      600: "#319795",
      700: "#2c7a7b",
      800: "#285e61",
      900: "#234e52",
    },
    "blue": {
      100: "#ebf8ff",
      200: "#bee3f8",
      300: "#90cdf4",
      400: "#63b3ed",
      500: "#4299e1",
      600: "#3182ce",
      700: "#2b6cb0",
      800: "#2c5282",
      900: "#2a4365",
    },
    "indigo": {
      100: "#ebf4ff",
      200: "#c3dafe",
      300: "#a3bffa",
      400: "#7f9cf5",
      500: "#667eea",
      600: "#5a67d8",
      700: "#4c51bf",
      800: "#434190",
      900: "#3c366b",
    },
    "purple": {
      100: "#faf5ff",
      200: "#e9d8fd",
      300: "#d6bcfa",
      400: "#b794f4",
      500: "#9f7aea",
      600: "#805ad5",
      700: "#6b46c1",
      800: "#553c9a",
      900: "#44337a",
    },
    "pink": {
      100: "#fff5f7",
      200: "#fed7e2",
      300: "#fbb6ce",
      400: "#f687b3",
      500: "#ed64a6",
      600: "#d53f8c",
      700: "#b83280",
      800: "#97266d",
      900: "#702459",
    },
  },
  boxShadow: {
    "container": "0 2px 4px 0 rgba(156, 166, 199, 0.18)",
    "header": "0 2px 34px 0 rgba(48,156,133,0.08)",
    "button": "1px 9px 20px -5px rgba(30,61,63,0.26)",
    "button-green": "0 9px 20px -5px rgba(48, 156, 133, .29)",
  },
  opacity: {
    10: "0.1",
    20: "0.2",
    95: "0.95",
  },
  borderWidth: {
    6: "6px",
    10: "10px",
  },
  backgroundColor: {
    "free-trial-pill": "#FFCA00",
    "boost-primary-purple": "#4B2BA3",
  },
};

const screens = {
  xs: '350px',
  sm: '640px',
  md: '768px',
  mdl: "850px",
  lg: '1024px',
  xl: '1180px',
  xxl: "1366px",
};

export default { tailwindExtensions, screens };
